import styled from "@emotion/styled";

import { fontSourceSerif4, theme } from "shared/lib/styles";

import { StyledArticleComment } from "scmp-app/components/content/content-action-bar/styles";
import { Figure, StyledFigcaption } from "scmp-app/components/content/content-cover-image/styles";
import {
  clickableFrameLinkStyles,
  clickableFrameStyles,
} from "scmp-app/components/content/content-item-render/clickable-frame/styles";
import { LinkHighlightArea } from "scmp-app/components/content/content-item-render/highlight/styles";
import {
  H2Container as ContentSubHeadlineH2Container,
  H3Container as ContentSubHeadlineH3Container,
} from "scmp-app/components/content/content-sub-headline/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: contents;

  color: #000000;
`;

export const StyledEntityLink = styled(EntityLink)``;

export const Content = styled.div`
  ${clickableFrameStyles(StyledEntityLink)}
  grid-area: primary-article;

  display: flex;
  flex-direction: column;

  /* scoped to the headline instance: the cover anchor is a child of Container, not Content */
  > ${StyledEntityLink} {
    ${clickableFrameLinkStyles}
  }
`;

export const StyledLinkHighlightArea = styled(LinkHighlightArea)`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Headline = styled.div`
  margin-block-end: 0;

  color: #000000;
  font-weight: 600;
  font-size: 24px;
  font-family: ${fontSourceSerif4};
  line-height: 120%;
  letter-spacing: -2.5%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 28px;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 8px;
  }
`;

export const LiveTagContainer = styled.div`
  margin-block-end: 8px;

  :empty {
    margin-block-end: 0;
  }
`;

export const SubHeadline = styled.div`
  display: block;

  color: #5a5a5a;
  font-size: 14px;
  font-family: ${fontSourceSerif4};
  line-height: 135%;
  letter-spacing: -0.14px;

  ${ContentSubHeadlineH2Container}, ${ContentSubHeadlineH3Container} {
    li + li {
      margin-block-start: 12px;
    }
  }
`;

export const ActionBar = styled.div`
  margin-block-start: 12px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 8px;
  }

  time,
  ${StyledArticleComment} {
    font-size: 11px;
    line-height: 100%;
    letter-spacing: 0%;
  }

  time {
    color: #727272;
  }
`;

export const CoverImage = styled.div`
  grid-area: primary-article-image-carousel;

  block-size: auto;
  /* Cancel the super-splash frame's padding-inline so the image spans the
     full frame width on mobile. */
  margin-inline: calc(-1 * var(--super-splash-frame-padding-inline, 16px));

  ${Figure} picture {
    display: block;
    aspect-ratio: 3/2;

    img {
      aspect-ratio: inherit;
    }
  }

  ${StyledFigcaption} {
    display: none;

    ${theme.breakpoints.up("tablet")} {
      display: block;

      line-height: 14px;
    }
  }
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 0;
    margin-inline: 0;
  }
`;
